const { REACT_APP_API_URL } = process.env;

const getCategories = async () => {
  const response = await fetch(`${REACT_APP_API_URL}category`);
  return response.json();
};

export default getCategories;
